// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Oihj","actions":"GroupTable_actions__6fS5B","deleteModalFooter":"GroupTable_deleteModalFooter__G1HeE"};